class Class {
  // Empty base class needed for compatibility with Kendo UI for jQuery
}
export { Class as default };